import { IUser, UserRole } from '../interfaces/User.interface';

export const isManagerOrAdmin = (user?: IUser): boolean => {
  const role = user?.role?.toLowerCase();
  return role === UserRole.Manager || role === UserRole.Admin;
};
